import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpAgency'

export const sponsorApplicationList = (params = '') => Http.get(`/showcase-sponsor-applications${serialize(params)}`)
export const sponsorApplicationByID = (params = '') => Http.get(`/showcase-sponsor-applications/${params}`)
export const sponsorApplicationConfirm = (id, data = {}) => Http.post(`/showcase-sponsor-applications/${id}/confirm`, data)
export const sponsorApplicationCancel = (id, data = {}) => Http.post(`/showcase-sponsor-applications/${id}/cancel`, data)
export const sponsorApplicationMarkPaid = (id, data = {}) => Http.post(`/showcase-sponsor-applications/${id}/mark-paid`, data)
export const sponsorApplicationUpdate = (params = {}) => Http.put(`/showcase-sponsor-applications/${params.id}`, params)
